import { render } from "./updateTransfere.vue?vue&type=template&id=50f72769&scoped=true"
import script from "./updateTransfere.vue?vue&type=script&lang=js"
export * from "./updateTransfere.vue?vue&type=script&lang=js"

import "./updateTransfere.vue?vue&type=style&index=0&id=50f72769&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f72769"]])

export default __exports__